import { moment } from "../date";
import { guardString } from "../strings";
import type { Nullable, Tables } from "../types";

type DeliveryWindowTourWave = Pick<Tables<"tourWaves">, "startTime" | "endTime">;

/**
 * Format an order's delivery date and the timespan of its tour wave as one string —
 * `"Di, 25.08.2026 / 06:00 - 10:00"`. An order without a tour wave has a delivery date but no
 * window, so the timespan is dropped rather than filled with placeholders.
 *
 * @param deliveryDate - The order's delivery date, as the date string the column stores.
 * @param tourWave - The wave the order ships on, carrying the times that bound the window.
 * @returns The date followed by the wave's timespan, the date alone when no wave is set, or the
 * `guardString` fallback when there is no delivery date.
 */
export function getDeliveryWindowString(
	deliveryDate: Nullable<string>,
	tourWave?: Nullable<DeliveryWindowTourWave>,
): string {
	if (!deliveryDate) return guardString(null);

	const date = moment(deliveryDate).dateFormat();
	if (!tourWave?.startTime || !tourWave?.endTime) return date;

	return `${date} / ${tourWave.startTime} - ${tourWave.endTime}`;
}
